import { createDecorator } from '../../instantiation/common/instantiation.js';
const ITerminalLogService = ( createDecorator('terminalLogService'));
export { ITerminalLogService };
